<template lang="html">
  <div v-if="isUserLoggedIn">
    <input id="nav-my-academics" class="accordion__state" type="checkbox" />
    <label
      class="accordion__toggle nav__link nav__link--neutral-100"
      for="nav-my-academics"
    >
      <span class="align-middle flex-container">
        <span class="flex-child-auto">
          <svg-icon icon-name="private-area" class-name="nav__icon" />
          {{ 'client.off_canvas_nav.my_academics' | t }}
        </span>
        <span class="flex-child-shrink">
          <svg-icon icon-name="chevron-thin" class-name="accordion__chevron" />
        </span>
      </span>
    </label>
    <div class="accordion__panel">
      <a
        class="accordion__toggle nav__sub-link nav__sub-link--gneiss"
        :href="searchProfilesLink"
      >
        {{ 'client.off_canvas_nav.my_search_profiles' | t }}
      </a>

      <a
        v-if="jobMarket === 'DACH'"
        class="accordion__toggle nav__sub-link nav__sub-link--gneiss"
        :href="downloadsLink"
      >
        {{ 'client.off_canvas_nav.downloads' | t }}
      </a>

      <a
        class="accordion__toggle nav__sub-link nav__sub-link--gneiss"
        :href="myAcademicsAccountLink"
      >
        {{ 'client.off_canvas_nav.manage_account' | t }}
      </a>
    </div>
  </div>
  <div v-else>
    <a
      class="accordion__toggle nav__link nav__link--neutral-100"
      :href="signInLink"
    >
      {{ 'client.off_canvas_nav.sign_in' | t }}
    </a>
  </div>
</template>

<script>
// TODO: pull the rest of _nav_off_canvas.*+fused.erb partials into this component
import { mapState, mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['isUserLoggedIn']),
    ...mapState(['links', 'user', 'jobMarket']),
    searchProfilesLink() {
      return this.links.searchProfiles
    },
    signInLink() {
      return this.links.signIn
    },
    myAcademicsAccountLink() {
      return this.links.myAcademicsAccount
    },
    downloadsLink() {
      return this.links.downloads
    },
    labLink() {
      return this.links.lab
    }
  }
}
</script>
